export enum PricingType {
  SAAS = 'SAAS',
  API = 'API',
  DATA_PACKS = 'DATA_PACKS'
}

export interface PricingTier {
  name: string;
  price: string; // Display price string
  monthlyPrice: number; // Numeric value for calculations
  period?: string;
  description: string;
  features: string[];
  highlight?: boolean;
  cta: string;
  recommended?: boolean;
  strikePrice?: string;
}

export interface Api {
  title: string;
  price: string;
  unit: string;
  description: string;
  highlightColor?: string;
}

export interface ComparisonItem {
  feature: string;
  genericList: boolean | string;
  proGeoData: boolean | string;
  enterpriseDb: boolean | string;
  icon?: string;
}